import { IntlShape } from '@formatjs/intl';

export class FormHelperUtil {
    static getFormFieldErrorTranslator(formName: string, intl: IntlShape) {
        return (fieldName: string, errors: any, errorFieldIntlValues: any = {}): string => {
            return intl.formatMessage({ id: `form.${formName}.${fieldName}.${errors[fieldName].type}` }, { ...errorFieldIntlValues });
        };
    }
}
